export const setItem = ( name, value ) => {
	if ( typeof value === 'object' ) {
		value = JSON.stringify ( value );
	}
	window.sessionStorage.setItem ( name, value );
};

export const getItem = name => {
	const data = window.sessionStorage.getItem ( name );
	try {
		return JSON.parse ( data );
	} catch ( err ) {
		return data;
	}
};

export const removeItem = name => {
	window.sessionStorage.removeItem ( name );
};
//存储本地实体信息
export const localSetAddress = ( addressInfo = {} ) => {
	window.localStorage.setItem ( "addressInfo", JSON.stringify ( addressInfo ) );
	
};
//获取本地实体地址信息
export const localGetAddress = ( name ) => {
	let addressInfo = window.localStorage.getItem ( "addressInfo" );
	return addressInfo ? JSON.parse ( addressInfo )[name] : "";
};

export const loaclSetUserInfo=(info={})=>window.localStorage.setItem("userInfo",JSON.stringify(info))

export const localGetUserInfo=(name)=>{
	let userInfo = window.localStorage.getItem ( "userInfo" );
	return userInfo ? JSON.parse ( userInfo )[name] : "";
}


